import { render } from "./SimpleAnswer.vue?vue&type=template&id=eb04ff02&scoped=true"
import script from "./SimpleAnswer.vue?vue&type=script&lang=js"
export * from "./SimpleAnswer.vue?vue&type=script&lang=js"

import "./SimpleAnswer.vue?vue&type=style&index=0&id=eb04ff02&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb04ff02"]])

export default __exports__